/*# sourceMappingURL=report-details.component-YW5BU527.css.map */
